export default __webpack_public_path__ + "static/media/SingleSource_logo_light.b07efe19.png";